import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import moment from "moment-timezone";
import { differenceInMinutes } from 'date-fns';

import { itemContext } from 'context';
import { accessor } from 'react-big-calendar/lib/utils/propTypes';
import { accessor as accessors } from 'react-big-calendar/lib/utils/accessors';
import { mergeComponents } from './common';
import { DnDContext } from './DnDContext';
import { 
    EventWrapper, 
    EventContainerWrapper, 
    WeekWrapper, 
    DateCellWrapper, 
    DayColumnWrapper, 
    EventCell, 
    TimeSlotWrapper,
    WeekHeader,
    DateHeader,
    TimeEventCell,
    DndContext
} from './components';

export default function withDragAndDrop(Calendar) {
    class DragAndDropCalendar extends React.Component {
        static propTypes = {
            ...Calendar.propTypes,

            onExtEventDrop: PropTypes.func,
            onEventDrop: PropTypes.func,
            onEventResize: PropTypes.func,
            onDragStart: PropTypes.func,
            onDragOver: PropTypes.func,
            onDropFromOutside: PropTypes.func,

            dragFromOutsideItem: PropTypes.func,

            draggableAccessor: accessor,
            resizableAccessor: accessor,

            selectable: PropTypes.oneOf([true, false, 'ignoreEvents']),
            resizable: PropTypes.bool,
        }

        static defaultProps = {
            ...Calendar.defaultProps,
            draggableAccessor: null,
            resizableAccessor: null,
            resizable: true,
            startAccessor: 'start',
            endAccessor:'end'
        }

        constructor(...args) {
            super(...args)

            const { components } = this.props
            this.state = { interacting: false }
            this.components = mergeComponents(components, 
                this.props.view === 'month' ? 
                {
                    eventWrapper: EventWrapper,
                    // eventContainerWrapper: EventContainerWrapper,
                    weekWrapper: WeekWrapper,
                    // dateCellWrapper: DateCellWrapper, // Control date slots interactions
                    dateCellWrapper: DateCellWrapper,
                    timeSlotWrapper: DateCellWrapper,
                    event: EventCell,
                    month: {
                        dateHeader: DateHeader
                    }
                } :
                {
                    eventWrapper: EventWrapper,
                    eventContainerWrapper: EventContainerWrapper, // Control time slots interactions
                    event: TimeEventCell,
                    timeSlotWrapper: TimeSlotWrapper,
                    week: {
                        header: WeekHeader
                    },   
                    work_week: {
                        header: WeekHeader
                    },                    
                }
            )

            
        }

        ////////////////////
        // Render helpers //
        ////////////////////
        eventPropGetter = (eventProps) => {
            const {allDay, end, item, start, title} = eventProps;
            const diff = differenceInMinutes(end, start)
            // console.log(item)
            const status = item['status']
            const priority = item['priority']
            const style = {
                display: diff < 60 ? 'flex' : 'block',
                flexDirection: diff < 60 && 'row',
                alignItems: diff < 60 && 'center',
                // color: status === itemContext.STATUS.INCOMPLETE ? 'var(--text-color)' : 'var(--text-color2)',
                // backgroundColor: status === itemContext.STATUS.INCOMPLETE ? itemContext.PRIORITY_COLOR_THREE[priority] : itemContext.PRIORITY_COLOR_TWO[priority],
                backgroundColor: 'var(--primary-accent-color)',
                borderLeft: `5px solid ${itemContext.PRIORITY_COLOR[priority]}`,
                opacity: status === itemContext.STATUS.INCOMPLETE ? 1 : 0.5,         
                margin: '0 0 1px 0',
                maxHeight: !allDay && moment.isMoment(end) ? `calc(${(end.diff(start,'minutes')/1440)*100}% - 2px)` : null
            }
            return {style: style}
            // console.log({allDay: allDay, end: end, start: start, item: item, title: title})
        }

        //////////////////////
        // Timezone helpers //
        //////////////////////
        convertDateTimeToDate = (datetime, timeZoneName) => {
            const m = moment.tz(datetime, timeZoneName);
            return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute(), 0)
        };
        
        convertDateToDateTime = (date, timeZoneName) => {
            const dateM = moment.tz(date, Calendar.tz);
            return moment.tz({
                year: dateM.year(),
                month: dateM.month(),
                date: dateM.date(),
                hour: dateM.hour(),
                minute: dateM.minute(),
            }, Calendar.tz);
        };

        
        startAccessor = (event) => {
            const start = accessors(event, this.props.startAccessor);
            // console.log('start',start, this.convertDateTimeToDate(start, this.props.timezone))
            return this.convertDateTimeToDate(start, this.props.timezone);
        };
        
        endAccessor = (event) => {
            const end = accessors(event, this.props.endAccessor);
            // console.log('end', this.convertDateTimeToDate(end, this.props.timezone))
            return this.convertDateTimeToDate(end, this.props.timezone);
        };

        /////////////////
        // DND helpers //
        /////////////////
        getDnDContextValue() {
            return {
                draggable: {
                    onStart: this.handleInteractionStart,
                    onEnd: this.handleInteractionEnd,
                    onBeginAction: this.handleBeginAction,
                    onDropFromOutside: this.props.onDropFromOutside,
                    dragFromOutsideItem: this.props.dragFromOutsideItem,
                    draggableAccessor: this.props.draggableAccessor,
                    resizableAccessor: this.props.resizableAccessor,
                    dragAndDropAction: this.state,
                },
                slotHandlers: {
                    onSlotDown: this.props.onSlotDown,
                    onSlotHover: this.props.onSlotHover,
                    onSlotUp: this.props.onSlotUp,
                    mouseDown: this.props.mouseDown
                },
                eventHandlers : {
                    onEventSelect: this.props.onEventSelect,
                    onEventContext: this.props.onEventContext,
                    onEventOver: this.props.onEventOver
                },
                dateHelpers: {
                    convertDateToDateTime: this.convertDateToDateTime,
                    convertDateTimeToDate: this.convertDateTimeToDate
                },
                extraProps: {...this.props},
            }
        }

        defaultOnDragOver = event => {
            event.preventDefault()
        }

        handleBeginAction = (event, action, direction) => {
            if(this.props.disableDND){
                return
            }
            this.setState({ event, action, direction })
            const { onDragStart } = this.props
            if (onDragStart) onDragStart({ event, action, direction })
        }

        handleInteractionStart = () => {
            if(this.props.disableDND){
                return
            }
            if (this.state.interacting === false) this.setState({ interacting: true })
        }

        handleInteractionEnd = interactionInfo => {
            const { action, event } = this.state
            if (!action) return

            this.setState({
                action: null,
                event: null,
                interacting: false,
                direction: null,
            })

            if (interactionInfo == null) return

            interactionInfo.event = event
            const { onEventDrop, onEventResize } = this.props
            if (action === 'move' && onEventDrop) onEventDrop(interactionInfo)
            if (action === 'resize' && onEventResize) onEventResize(interactionInfo)
        }

        render() {
            const { selectable, elementProps, ...props } = this.props
            const { interacting } = this.state

            delete props.onEventDrop
            delete props.onEventResize
            props.selectable = selectable ? 'ignoreEvents' : false

            const elementPropsWithDropFromOutside = this.props.onDropFromOutside
                ? {
                    ...elementProps,
                    onDragOver: this.props.onDragOver || this.defaultOnDragOver,
                }
                : elementProps

            props.className = clsx(
                props.className,
                'rbc-addons-dnd',
                !!interacting && 'rbc-addons-dnd-is-dragging'
            )

            const context = this.getDnDContextValue()

            return (
                <DnDContext.Provider value={context}>
                    {/* <DndContext> */}
                        <Calendar
                            {...props}
                            date={this.convertDateTimeToDate(this.props.date, this.props.timezone)}
                            getNow={this.props.getNow}
                            elementProps={elementPropsWithDropFromOutside}
                            components={this.components}
                            startAccessor={this.startAccessor}
                            endAccessor={this.endAccessor}
                            eventPropGetter={this.eventPropGetter}
                            popup={true}
                            doShowMoreDrillDown={false}
                            messages={{
                                showMore: (total) => (`${total} more`)
                            }}
                            onShowMore={this.props.onShowMore}
                            popupOffset={this.state.popupOffset}
                        />
                    {/* </DndContext> */}
                </DnDContext.Provider>
            )
        }
    }
    return DragAndDropCalendar
}